<template>
  <ContextColorProvider class="rlp" context="trade">
    <FadeTransition>
      <Information
        v-if="currentStep === RLPSteps.Information"
        :page-data="pageData"
        :page-status="pageStatus"
        @change-step="handleChangeStep"
        @refresh="handlePageRefresh"
      />
      <CancellationForm
        v-else-if="currentStep === RLPSteps.CancellationForm"
        :page-data="pageData"
        @change-step="handleChangeStep"
        @refresh="handlePageRefresh"
      />
    </FadeTransition>
  </ContextColorProvider>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';

import { ContextColorProvider } from '@warrenbrasil/nebraska-web';
import { Information } from './components/Information';
import { CancellationForm } from './components/CancellationForm';
import { FadeTransition } from '@/modules/common/components/FadeTransition';

import { RLPSteps, RLPPageStatus } from './types';
import { RLPPageData, getRLPStatus } from '@/modules/trade/services/rlp';

const currentStep = ref<RLPSteps>(RLPSteps.Information);

const pageData = ref<RLPPageData | null>(null);
const pageStatus = ref<RLPPageStatus>(RLPPageStatus.Loading);

const handleChangeStep = (step: RLPSteps) => {
  currentStep.value = step;
};

const handlePageRefresh = async () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  await fetchRLPData();
};

const fetchRLPData = async () => {
  try {
    pageStatus.value = RLPPageStatus.Loading;

    pageData.value = await getRLPStatus();

    pageStatus.value = RLPPageStatus.Default;
  } catch {
    pageStatus.value = RLPPageStatus.Error;
  }
};

onMounted(async () => {
  await fetchRLPData();
});
</script>

<style lang="less" scoped></style>
